import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AbstractModal } from "../../../../shared/models/abstract-modal";

@Component({
  selector: "app-licence-modal",
  templateUrl: "./licence-modal.component.html",
  styleUrls: ["./licence-modal.component.scss"],
})
export class LicenceModalComponent extends AbstractModal {
  constructor(protected ngbActiveModal: NgbActiveModal) {
    super(ngbActiveModal);
  }
}
